<ion-card>
    <ion-card-header>
        <ion-card-subtitle>
            Klaar voor de volgende bestelling?
        </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
        <div>
            <p>{{nextOrder.client.getAddress()}}</p>
            <p><b>{{nextOrder.client.distanceInKm}} KM | {{nextOrder.client.travelTimeInMinutes}} min</b>
        </div>
        <ion-progress-bar class="ion-margin-top" [value]="progressBarValue"></ion-progress-bar>
        <div class="actions">
            <ion-button (click)="startNextOrder()" expand="block" color="secondary">GO</ion-button>
            <ion-button (click)="closeModal()" expand="block" color="primary">Cancel</ion-button>
        </div>
    </ion-card-content>
</ion-card>